module.exports = __webpack_public_path__ + "static/media/Go4-Logo-Red.85b183f6.svg";